:host {
  display: block;

  .av-date-picker {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: center;
    margin: 5px 0;
  }

  // .av-date-picker-dark {
  //   .av-date-picker-option {
  //     color: var(--av-font-color-light);
  //   }
  //   .av-arrow-down {
  //     &:after {
  //       border-right: 2px solid var(--av-font-color-light);
  //       border-bottom: 2px solid var(--av-font-color-light);
  //     }
  //   }
  // }

  .av-date-picker-option {
    @include option-panel;
    text-align: left;
    cursor: pointer;
    text-transform: capitalize;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: var(--av-card-color);
    .av-arrow-down:after {
      transition: transform 0.2s ease-out, top 0.2s ease-out;
    }
    &.active {
      //   background-color: var(--av-color-accent);
      //   color: var(--av-color-accent-contrast);
      //   border-color: var(--av-color-accent);
      .av-arrow-down {
        &:after {
          // transform: rotate(-135deg);
          // top: 25px;
          border-right: 2px solid var(--av-color-accent-contrast);
          border-bottom: 2px solid var(--av-color-accent-contrast);
        }
      }
    }
    small {
      opacity: 0.8;
      font-weight: normal;
    }
  }

  .av-arrow-down {
    position: relative;
    &:after {
      @include arrow-down;
      top: -8px;
      right: 0;
    }
  }

  .av-date-picker-option-future {
    position: relative;
    .av-date-picker-option {
      width: 100%;
    }
    img {
      width: 20px;
    }
  }

  .av-card-calendar {
    div.av-card {
      width: 100%;
      &.av-card-floating {
        bottom: auto;
        top: 50px;
      }
      .av-card-body {
        padding: 0;
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .av-card-calendar {
    div.av-card {
      width: 250px;
      &.av-card-closed {
        display: none;
      }
    }
  }
}

.av-direction {
  direction: var(--av-direction);
}
